import React from 'react';
import ReactDOM from 'react-dom/client';

import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileState from 'filestate/FileState';
import {EntryFileState, SubtemplateFileState, TemplateFileState} from 'FileStates';
import ResourcePresenceManager from 'nav/presence/ResourcePresenceManager';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';
import EntityStore from 'stores/EntityStore';

export default class PresenceManager {
  mount!: JQuery;
  mounted!: boolean;
  reactRoot: ReactDOM.Root | null = null;

  constructor(mount: JQuery) {
    assert(mount && mount.length === 1, 'expected realtime presence mount point');
    this.mount = mount;
    this.mounted = false;
  }

  subscribe(file: FileState | null): void {
    if (!presenceEnabled()) {
      this.unsubscribe();
      return;
    }

    const fileId = getResourceIdForRealtime(file);
    if (!fileId) {
      this.unsubscribe();
      return;
    }

    this.reactRoot = renderToDOM(<ResourcePresenceManager fileId={fileId} />, this.mount[0], this.reactRoot);

    this.mounted = true;
  }

  unsubscribe(): void {
    if (this.mounted) {
      unmountRootsAsync([this.reactRoot], () => {
        this.reactRoot = null;
      });
      this.mounted = false;
    }
  }
}

function presenceEnabled(): boolean {
  return EntityStore.currentUser() != null;
}

/**
 * Returns a resource ID for the FileState if the resource type is supported by the realtime
 * presence system.
 *
 * @param fileState the FileState
 * @returns the resource ID (API identifier) or null if the folder item is null or not supported by presence.
 */
export function getResourceIdForRealtime(fileState: FileState | null): string | null {
  let id: string | null = null;
  if (!fileState) {
    return null;
  }

  switch (fileState.fileType()) {
    case ModelTypeConstants.ENTRY:
    case ModelTypeConstants.TEMPLATE:
      ({id} = (fileState as EntryFileState | TemplateFileState).model());
      break;
    case ModelTypeConstants.SUBTEMPLATE:
      if (!BenchlingConfig.ELN_REALTIME_TEMPLATE_UPDATES) {
        return null;
      }
      ({id} = (fileState as SubtemplateFileState).model());
      break;
    default:
      return null;
  }

  return id;
}
